import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { conditionalFields, formFields, isArrayEqual, transformRails } from '@app/utils/railsUtils';
import { validateConditionalFields, validateFormFields } from '@app/utils/validateUtils';
import update from 'immutability-helper';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import CreateView from '@app/components/common/views/CreateView';

import { RailForm } from './RailForm';

export const CreateRails = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageType = searchParams.get('type');

  const [selected, setSelected] = useState<GenericObject[]>([]);
  const [firstRenderSelected, setFirstRenderSelected] = useState<GenericObject[]>([]);
  const validate = useCallback((values: GenericObject) => {
    const errors = validateFormFields({ fields: formFields, values });
    const conditionalFieldsErrors = validateConditionalFields({ fields: conditionalFields, values });
    return { ...errors, ...conditionalFieldsErrors };
  }, []);

  const handleChangeSelected = (values: GenericObject[]) => {
    setSelected(values);
  };

  const handleChangeFirstRenderSelected = (values: GenericObject[]) => {
    setFirstRenderSelected(values);
  };

  const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
    setSelected((prevCards) =>
      update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      })
    );
  }, []);

  const transform = (values: GenericObject) => {
    values.page_type = pageType;
    return transformRails(selected, values);
  };

  const customDiscardValidation = () => {
    return isArrayEqual(firstRenderSelected, selected);
  };

  return (
    <CreateView
      transform={transform}
      customDiscardValidation={customDiscardValidation}
      resourceSingular="rail"
      redirect={`/rails?type=${pageType}`}
      validate={validate}>
      <RailForm
        moveCard={moveCard}
        selected={selected}
        handleChangeFirstRenderSelected={handleChangeFirstRenderSelected}
        handleChangeSelected={handleChangeSelected}
        title="CREATE RAIL"
        type={pageType}
      />
    </CreateView>
  );
};
